import React, { useEffect } from "react";
import { node, bool, func, string, object } from "prop-types";
import { ESCAPE_KEY_CODE } from "./constants";
import { ModalContextProvider } from "./ModalManagement/ModalContext";
import { MODAL_TYPES } from "./ModalManagement/constants";
import { ModalPortal } from "./Portal/ModalPortal";
import { ModalLayout } from "./Layout/ModalLayout";
import { ModalHeader } from "./Header/ModalHeader";
import { ModalFooter } from "./Footer/ModalFooter";
import { ModalBody } from "./Body/ModalBody";
import { ModalSymbol } from "./Symbol/ModalSymbol";
import { ModalTopHeaderText } from "./TopHeaderText/ModalTopHeaderText";
import { ModalTitle } from "./Title/ModalTitle";
import { ModalSubTitle } from "./Title/ModalSubTitle";
import { ModalButton } from "./Button/ModalButton";
import styles from "./modal.module.css";
import { DEFAULT_WRAPPER_ID } from "./Portal/utils";
export var Modal = function Modal(_ref) {
  var children = _ref.children,
    isFooterSticky = _ref.isFooterSticky,
    isContentCentered = _ref.isContentCentered,
    isOpen = _ref.isOpen,
    withIllustration = _ref.withIllustration,
    onClose = _ref.onClose,
    onOutsideClick = _ref.onOutsideClick,
    onSubmit = _ref.onSubmit,
    wrapperClassName = _ref.wrapperClassName,
    wrapperId = _ref.wrapperId,
    wrapperProps = _ref.wrapperProps;
  var type = withIllustration && MODAL_TYPES.ILLUSTRATION || MODAL_TYPES.REGULAR;
  var contextValue = {
    type: type,
    isFooterSticky: isFooterSticky,
    isOpen: isOpen,
    withIllustration: withIllustration,
    onClose: onClose,
    onOutsideClick: onOutsideClick,
    onSubmit: onSubmit,
    wrapperProps: wrapperProps
  };
  useEffect(function () {
    var closeOnEscapeKey = function closeOnEscapeKey(event) {
      if (event.keyCode === ESCAPE_KEY_CODE) {
        onClose();
      }
    };
    document.body.addEventListener("keydown", closeOnEscapeKey);
    return function () {
      document.body.classList.remove(styles["jds-Body--withModal"]);
      document.body.removeEventListener("keydown", closeOnEscapeKey);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (isOpen) {
      document.body.classList.add(styles["jds-Body--withModal"]);
    } else {
      document.body.classList.remove(styles["jds-Body--withModal"]);
    }
  }, [isOpen]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ModalPortal, {
    wrapperId: wrapperId
  }, /*#__PURE__*/React.createElement(ModalContextProvider, {
    initialValue: contextValue
  }, /*#__PURE__*/React.createElement(ModalLayout, {
    wrapperClassName: wrapperClassName,
    isContentCentered: isContentCentered
  }, children)));
};
Modal.propTypes = {
  children: node,
  isFooterSticky: bool,
  isOpen: bool,
  withIllustration: bool,
  onClose: func,
  onOutsideClick: func,
  onSubmit: func,
  isContentCentered: bool,
  wrapperClassName: string,
  wrapperId: string,
  // eslint-disable-next-line react/forbid-prop-types
  wrapperProps: object
};
Modal.defaultProps = {
  children: null,
  isFooterSticky: false,
  isOpen: false,
  withIllustration: false,
  onClose: function onClose() {},
  onOutsideClick: function onOutsideClick() {},
  onSubmit: null,
  isContentCentered: false,
  wrapperClassName: null,
  wrapperId: DEFAULT_WRAPPER_ID,
  wrapperProps: null
};
Modal.Header = ModalHeader;
Modal.Symbol = ModalSymbol;
Modal.TopHeaderText = ModalTopHeaderText;
Modal.Title = ModalTitle;
Modal.SubTitle = ModalSubTitle;
Modal.Footer = ModalFooter;
Modal.Button = ModalButton;
Modal.Body = ModalBody;